const TopNavBarSpan = ({ topTab, selectTab, tabName, tabText }) => {
  const isActive = topTab === tabName;

  return (
    <span
      className={`teacher-nav__tab${isActive ? " teacher-nav__tab--active" : ""}`}
      onClick={() => selectTab(tabName)}
    >
      {tabText}
      {isActive && <span className="teacher-nav__tab-underline" />}
    </span>
  );
};

export default TopNavBarSpan;
